"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerSuccessBook = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const SchedulerSuccessBook = () => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex-1 flex-center flex-column', children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/images/help-bubble.svg', className: 'flex-none icon-60px mb-12px' }), (0, jsx_runtime_1.jsx)("div", { className: 'text-heading-lg-med text-gray-100', children: labels_1.default.SCHEDULER_BOOKED_SUCCESS_MESSAGE }), (0, jsx_runtime_1.jsx)("div", { className: 'text-body-s-reg text-gray-80', children: labels_1.default.SCHEDULER_BOOKED_SUCCESS_MESSAGE_CHECK_INBOX })] }));
};
exports.SchedulerSuccessBook = SchedulerSuccessBook;
